export default __webpack_public_path__ + "static/media/2star-b.82d1cd3a.png";